module.exports = __webpack_public_path__ + "img/86ne.c2c055bc.svg";